import {
  CustomViewAttribute,
  CustomViewFormConditionField,
} from 'src/graphql/entities/custom-view/custom-view.types';

const SERVICE_LEVEL_ATTRIBUTES = new Set(['serviceLevel', 'clientActivatedMembership']);

/**
 * Strips service-level columns and filters from a custom view entity config
 * when the partner does not have access to platform SLAs.
 */
export function filterServiceLevelAttributes<
  T extends {
    attributesList: CustomViewAttribute[];
    attributesMap: Map<string, CustomViewAttribute>;
    filterAttributesList: CustomViewFormConditionField[];
    filterAttributesMap: Map<string, CustomViewFormConditionField>;
  },
>(config: T, hasServiceLevelAccess: boolean): T {
  if (hasServiceLevelAccess) return config;

  const attributesList = config.attributesList.filter(
    (attr) => !SERVICE_LEVEL_ATTRIBUTES.has(attr.attribute),
  );

  const attributesMap = new Map(config.attributesMap);
  for (const key of SERVICE_LEVEL_ATTRIBUTES) {
    attributesMap.delete(key);
  }

  const filterAttributesList = config.filterAttributesList.filter(
    (attr) => !SERVICE_LEVEL_ATTRIBUTES.has(attr.value),
  );

  const filterAttributesMap = new Map(config.filterAttributesMap);
  for (const key of SERVICE_LEVEL_ATTRIBUTES) {
    filterAttributesMap.delete(key);
  }

  return {
    ...config,
    attributesList,
    attributesMap,
    filterAttributesList,
    filterAttributesMap,
  };
}
